import { DynamicFormRequiredType, type DynamicFormSettings } from '@myosh/odin-components';
import i18next from '../../../../i18n';
import type { FormBuilderField } from '../../../../redux/slices/form-builder-slice';
import { positiveIntMinOnePattern } from '../../../../utils/validation-utils';

export const textAreaFieldFormSettings: DynamicFormSettings = {
  id: 'TextAreaFieldSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'numberOfLines',
      fieldType: 'INTFIELD',
      fieldName: 'numberOfLines',
      dynamicProperties: {
        validations: [
          {
            pattern: positiveIntMinOnePattern,
            errorLabel: `${i18next.t('min-value')}: 1`,
          },
        ],
      },
      caption: i18next.t('number-of-lines'),
      position: 40,
      required: DynamicFormRequiredType.Partial,
      permissions: { read: true, edit: true },
    },
  ],
};

export const getTextAreaValues = (field: FormBuilderField) => {
  return {
    numberOfLines: field.numberOfLines,
  };
};
